import { Grid, TextField, Button, Alert, Typography, CircularProgress } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { sendMagicLinkService } from "../services/loginService";
import { useState } from "react";

const Login = () => {
  const [hasSentMagicLink, setHasSentMagicLink] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data) => {
    setErrorMessage("");
    setSubmitting(true);
    const res = await sendMagicLinkService(data);
    setSubmitting(false);

    if (res?.ok) {
      setHasSentMagicLink(true);
      return;
    }

    if (res?.status === 404) {
      setErrorMessage("No user found for that email.");
      return;
    }

    if (res?.status === 503) {
      setErrorMessage("Auth database is unavailable right now. Please try again shortly.");
      return;
    }

    if (res?.status === 400) {
      setErrorMessage(res.error || "Invalid email format.");
      return;
    }

    setErrorMessage(res?.error || "Could not send login link. Please try again.");
  };
  
  return (
    <>
    { !hasSentMagicLink ? (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container textAlign="center" spacing={3} justifyContent="center">
        <Grid item xs={7}>
          <Controller
            name="email"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                fullWidth
                {...field}
                label="Email"
                type="email"
                onChange={(e) => {
                  setErrorMessage("");
                  field.onChange(e);
                }}
              />
            )}
          />
          {errors.email ? <Alert severity="error">Email is required.</Alert> : null}
          {errorMessage ? <Alert sx={{ mt: 1 }} severity="error">{errorMessage}</Alert> : null}
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" disabled={submitting}>
            {submitting ? <CircularProgress size={20} color="inherit" /> : "Send Magic Link"}
          </Button>
        </Grid>
      </Grid>
    </form> )
    : (
      <Grid container spacing={2} justifyContent="center" textAlign="center">
        <Grid item xs={12}>
          <Typography>
            Login link sent. Check your inbox (and spam folder) to sign in.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="outlined"
            onClick={() => {
              setHasSentMagicLink(false);
              setErrorMessage("");
            }}
          >
            Use a different email
          </Button>
        </Grid>
      </Grid>
    ) }
  </>
  );
};

export default Login;
